// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1FQJV","modalForm":"UpgradeEpcsModal_modalForm__Lex3m","modalFooter":"UpgradeEpcsModal_modalFooter__jj-1q"};